export { ItStepper } from './it-stepper.js';
export { ItStepperStep } from './it-stepper-step.js';
import '../index-Blpj1lVH.js';
import 'lit/directive.js';
import 'lit';
import 'lit/decorators.js';
import 'lit/directives/if-defined.js';

const STEPPER_HEADER_VARIANTS = ['text', 'icons', 'numbers'];
const STEPPER_MOBILE_PROGRESS = ['bar', 'dots', ''];

export { STEPPER_HEADER_VARIANTS, STEPPER_MOBILE_PROGRESS };
//# sourceMappingURL=index.js.map
